import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { DialInput as DialInputModal } from '../../modals/dialInput';
const translatePayload = (node) => {
    const { next_node_id } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: next_node_id || uuid(),
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { next_node_id: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
const translateScopeVariables = (node) => {
    const { variable_id } = node.payload;
    const grants = variable_id ? [variable_id] : [];
    return {
        grants,
        needs: [],
    };
};
export const DialInputNodeAttributes = {
    iconName: 'phone',
    label: 'Dial input',
    helpText: 'Allow customers to give input with their dial pad during a call (e.g. a PIN, ZIP code, or phone number).',
    color: hexStringToNumber(flowNodeColor.orange),
    translateScopeVariables,
    translatePayload,
    updateConnection,
    NodeContent: DialInputNode,
    ActionModal: DialInputModal,
};
export function DialInputNode({ node }) {
    const { payload } = node;
    const { variable_id } = payload;
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "Variable" }), _jsx(Text, { weight: "semibold", text: variable_id })] })), [variable_id]) }));
}
